const webSite = {
    state: {
        language: 'CN',
        device: 'PC',
        baseLabel: {
            '开放时间': {
                EN: 'HOURS',
                CN: '开放时间'
            },
            '联系我们': {
                EN: 'CONTACT',
                CN: '联系我们'
            },
            '地址': {
                EN: 'ADDRESS',
                CN: '地址'
            },
            '电话': {
                EN: 'Tel',
                CN: '电话'
            },
            '邮箱': {
                EN: 'Email',
                CN: '邮箱'
            },
            '开幕时间': {
                EN: 'Open Now',
                CN: '开幕时间'
            },
            '展览时间': {
                EN: 'Exhibition Time',
                CN: '展览时间'
            },
            '艺术家': {
                EN: 'ARTISTS',
                CN: '艺术家'
            },
            '展览': {
                EN: 'EXHIBITIONS',
                CN: '展览'
            },
            '博览会': {
                EN: 'FAIRS',
                CN: '博览会'
            },
            '视野': {
                EN: 'VISION',
                CN: '视野'
            },
            '关于': {
                EN: 'ABOUT',
                CN: '关于'
            },
            '关闭': {
                EN: 'CLOSE',
                CN: '关闭'
            },
            '下载完整版艺术家简历': {
                EN: 'Download the full artist bio',
                CN: "下载完整版艺术家简历"
            },
            '下载完整版艺术家作品': {
                EN: "Download the full artist works",
                CN: "下载完整版艺术家作品"
            },
            '艺术家作品': {
                EN: "ARTIST WORKS",
                CN: "艺术家作品"
            },
            '展览作品': {
                EN: "EXHIBITION WORKS",
                CN: "展览作品"
            },
            '博览会作品': {
                EN: "FAIRS WORKS",
                CN: "博览会作品"
            },
            '尺寸': {
                EN: "Size",
                CN: "尺寸"
            },
            'in尺寸': {
                EN: "In Size",
                CN: "in尺寸"
            },
            '材质': {
                EN: "Material",
                CN: "材质"
            },
            '年份': {
                EN: "Years",
                CN: "年份"
            },
            '售价': {
                EN: "Price",
                CN: "售价"
            },
            '作品预览': {
                EN: "Work Preview",
                CN: "作品预览"
            },
            '下载预览': {
                EN: "Download Preview",
                CN: "下载预览"
            },
            '搜索': {
                EN: "SEARCH",
                CN: "搜索"
            },
            '技术支持': {
                EN: "Technical Support",
                CN: "软件技术支持"
            },
        }
    },

    mutations: {
        SET_LANGUAGE: (state, language) => {
            state.language = language
        },
        SET_DEVICE: (state, device) => {
            state.device = device
        },
    },
    actions: {

    }
}

export default webSite